import { ref } from 'vue'

import type { ContentItemDownloadRequest } from '../ui-library/components/ContentItemOverview/content-item-details.types'
import { downloadFileFromUrl } from '../utils'

export type GetAssetDownloadUrl = (
  contentItemId: string,
  assetId: string,
) => Promise<{ url: string }>

export type UseMediaDownloadOptions = {
  getAssetDownloadUrl: GetAssetDownloadUrl
}

export const useMediaDownload = ({ getAssetDownloadUrl }: UseMediaDownloadOptions) => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)

  const downloadFile = async ({
    contentItemId,
    assetId,
    url,
  }: ContentItemDownloadRequest): Promise<void> => {
    try {
      isLoading.value = true
      error.value = null

      const downloadUrl = assetId ? (await getAssetDownloadUrl(contentItemId, assetId)).url : url

      await downloadFileFromUrl(downloadUrl, `media-${contentItemId}`)
    } catch (e: unknown) {
      error.value = e as Error
      throw e
    } finally {
      isLoading.value = false
    }
  }

  return {
    downloadFile,
    isLoading,
    error,
  }
}
